import { identity } from './identity';
/**
 * Pipes the value of an expression into a pipeline of functions.
 *
 * @example
 * ```typescript
 * const len = (s: string): number => s.length;
 * const double = (n: number): number => n * 2;
 *
 * // Without pipe
 *
 * const doubleLen = (s: string) => double(len(s));
 *
 * // With pipe
 * const doubleLen = pipe(len, double);
 * ```
 */
export const pipe = (fn1, ...fns) => {
    const piped = fns.reduce((prevFn, nextFn) => (value) => nextFn(prevFn(value)), identity);
    return (...args) => piped(fn1(...args));
};
//# sourceMappingURL=pipe.js.map